// extracted by mini-css-extract-plugin
export default {"main":"CourseOverview_main__S1SrL","button":"CourseOverview_button__ywWL0"};